import { Search, X } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const ALL = '__all';
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const PRESETS = [
  ['Bugün', () => { const t = new Date(); return [iso(t), iso(t)]; }],
  ['7 gün', () => { const t = new Date(); const f = new Date(); f.setDate(t.getDate() - 6); return [iso(f), iso(t)]; }],
  ['Bu ay', () => { const t = new Date(); return [iso(new Date(t.getFullYear(), t.getMonth(), 1, 12)), iso(t)]; }],
  ['Geçen ay', () => { const t = new Date(); return [iso(new Date(t.getFullYear(), t.getMonth() - 1, 1, 12)), iso(new Date(t.getFullYear(), t.getMonth(), 0, 12))]; }],
  ['Bu yıl', () => { const t = new Date(); return [iso(new Date(t.getFullYear(), 0, 1, 12)), iso(t)]; }],
];

function Pick({ value, onChange, placeholder, options, testId }) {
  return (
    <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? '' : v)}>
      <SelectTrigger className="h-9 w-full sm:w-44 rounded-xl text-sm" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>{placeholder}</SelectItem>
        {options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function SubsFilters({ f, set, opts, onReset }) {
  const inCls = 'h-9 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 text-sm outline-none focus:border-orange-500';
  const active = Object.entries(f).some(([k, v]) => v && k !== 'q') || f.q;
  return (
    <div className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white/70 dark:bg-slate-900/70 backdrop-blur p-3 space-y-3" data-testid="fuel-filters">
      <div className="flex flex-wrap items-center gap-2">
        <input type="date" value={f.date_from} onChange={(e) => set({ date_from: e.target.value })} className={inCls} data-testid="fuel-f-from" />
        <span className="text-slate-400 text-sm">–</span>
        <input type="date" value={f.date_to} onChange={(e) => set({ date_to: e.target.value })} className={inCls} data-testid="fuel-f-to" />
        <div className="flex flex-wrap gap-1">
          {PRESETS.map(([l, fn]) => (
            <button key={l} type="button" onClick={() => { const [a, b] = fn(); set({ date_from: a, date_to: b }); }}
              className="h-8 px-3 rounded-full text-xs font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-orange-100 hover:text-orange-700 transition-colors" data-testid={`fuel-f-preset-${l}`}>{l}</button>
          ))}
        </div>
        <div className="relative ml-auto w-full sm:w-64">
          <Search className="h-4 w-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Ara: şoför, plaka, not, ticket…" className={`${inCls} w-full pl-9`} data-testid="fuel-f-search" />
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Pick value={f.employee_id} onChange={(v) => set({ employee_id: v })} placeholder="Tüm şoförler" options={(opts.drivers || []).map((d) => [d.id, d.name])} testId="fuel-f-driver" />
        <Pick value={f.plate} onChange={(v) => set({ plate: v })} placeholder="Tüm plakalar" options={(opts.plates || []).map((p) => [p, p])} testId="fuel-f-plate" />
        {(opts.firms || []).length > 1 && <Pick value={f.firm_id} onChange={(v) => set({ firm_id: v })} placeholder="Tüm firmalar" options={opts.firms.map((x) => [x.id, x.name])} testId="fuel-f-firm" />}
        <Pick value={f.ai_status} onChange={(v) => set({ ai_status: v })} placeholder="Okuma: hepsi" options={[['done', 'Okundu'], ['error', 'Okunamadı'], ['running', 'Okunuyor'], ['idle', 'Sırada']]} testId="fuel-f-ai" />
        <Pick value={f.card_company} onChange={(v) => set({ card_company: v })} placeholder="Tüm kart firmaları" options={(opts.card_companies || []).map((c) => [c, c])} testId="fuel-f-card" />
        {active && (
          <button type="button" onClick={onReset} className="h-9 px-3 rounded-xl text-xs font-semibold text-rose-600 hover:bg-rose-50 inline-flex items-center gap-1" data-testid="fuel-f-reset"><X className="h-3.5 w-3.5" />Temizle</button>
        )}
      </div>
    </div>
  );
}
